import i18next from "i18next";
import { useContext, useEffect, useRef } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import InteractiveContext from "../../context/InteractiveContext";

const VideoJS = ({
  options,
  onPlayerReady,
  onVideoTimeUpdate,
  onVideoClick,
  onVideoPlay,
  onVideoLoadedMetadata,
  onVideoPause,
  onVideoError,
  onVideoEnded,
  currentVideoId,
}) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement) return;
      const player = (playerRef.current = videojs(
        videoElement,
        { preload: "auto", ...options },
        () => {
          onPlayerReady && onPlayerReady(player);
        }
      ));
    }
  }, [options, videoRef, onPlayerReady]);

  const { isMuted, toggleMuted } = useContext(InteractiveContext);

  const onVolumeChanged = (e) => {
    if (!playerRef.current) {
      return;
    }
    if (playerRef.current.muted() !== isMuted) {
      toggleMuted(playerRef.current.muted());
    }
  };
  var isSafari =
    navigator.vendor &&
    navigator.vendor.indexOf("Apple") > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf("CriOS") == -1 &&
    navigator.userAgent.indexOf("FxiOS") == -1;
  console.log(isSafari);
  // const styles = isSafari ? { height: "100%" } : "";

  return (
    <div data-vjs-player className="overflow-hidden">
      <video
        onVolumeChange={onVolumeChanged}
        muted={isMuted}
        ref={videoRef}
        className={`video-js vjs-big-play-centered ${
          isSafari ? "classSafari" : ""
        }`}
        onTimeUpdate={onVideoTimeUpdate}
        onLoadedMetadata={onVideoLoadedMetadata}
        onEnded={onVideoEnded}
        onClick={onVideoClick}
        onPause={onVideoPause}
        onPlay={onVideoPlay}
        onError={onVideoError}
        disablePictureInPicture
      />
    </div>
  );
};

export default VideoJS;
